import { AppRoutes } from "@/routes/config";
import { useEffect } from "react";

const Home = () => {
  useEffect(() => {
    location.href = AppRoutes.organizationList;
  }, []);
  return <></>;
};

export default Home;
